import { apiClient } from './api'

export interface ProjectActionItem {
  id: number
  project_id: number
  title: string
  assigned_to: string | null
  due_date: string | null
  status: string | null
  priority: string | null
  source: string | null
  source_details: Record<string, unknown> | null
  position: number
  created_at: string | null
  updated_at: string | null
}

export interface ProjectActionCreate {
  title: string
  assigned_to?: string | null
  due_date?: string | null
  status?: string | null
  priority?: string | null
  source?: string | null
  source_details?: Record<string, unknown> | null
  position?: number
}

export const projectActionsService = {
  list(projectId: number): Promise<ProjectActionItem[]> {
    return apiClient.get(`/api/v1/projects/${projectId}/actions/`).then((r) => r.data)
  },
  create(projectId: number, body: ProjectActionCreate): Promise<ProjectActionItem> {
    return apiClient.post(`/api/v1/projects/${projectId}/actions/`, body).then((r) => r.data)
  },
  get(projectId: number, itemId: number): Promise<ProjectActionItem> {
    return apiClient.get(`/api/v1/projects/${projectId}/actions/${itemId}`).then((r) => r.data)
  },
  update(projectId: number, itemId: number, body: Partial<ProjectActionCreate>): Promise<ProjectActionItem> {
    return apiClient.patch(`/api/v1/projects/${projectId}/actions/${itemId}`, body).then((r) => r.data)
  },
  delete(projectId: number, itemId: number): Promise<void> {
    return apiClient.delete(`/api/v1/projects/${projectId}/actions/${itemId}`)
  },
}
